<template>
  <div>
    <h5 class="ml-4">Instructions</h5>
    <ol v-if="anyWalletCoin && this.anyWalletCoin.networkMsg != ''">
      <li v-for="(instruction, i) in instructionsListdata" :key="i">
        <span
          v-html="instruction.indexOf('[wallet]') > -1
            ? instruction.replace('[wallet]', anyWalletCoin.name)
            : instruction" />
      </li>
    </ol>
    <ol v-if="anyWalletCoin && anyWalletCoin.networkMsg == ''">
      <li v-for="(instruction, i) in processedInstructionsList" :key="i">
        <span
          v-html="instruction.indexOf('[wallet]') > -1
            ? instruction.replace('[wallet]', anyWalletCoin.name)
            : instruction" />
      </li>
    </ol>
    <p class="instruction-note ml-2">
      <b>{{$t('qr-wallet.instructionsNote')}}</b>
    </p>
  </div>
</template>
<script>
import { CCD_NETWORK_TOKENS } from '@/utils/stringconsts';

export default {
  props: {
    anyWalletCoin: Object,
    store: Object,
  },
  data() {
    return {
      instructionsList: this.$t('qr-wallet.instructionsList'),
      // instructionsListdata: null,
    };
  },
  computed: {
    instructionsListdata() {
      const label = this.store?.whiteLabel?.colorSchema?.partnerLabel || this.brandName;
      const currency = this.anyWalletCoin?.currency?.toUpperCase() || '';
      const isCCDNetworkToken = CCD_NETWORK_TOKENS.includes(currency);
      
      const cloneSheeps = [
        'Open your <b>Wallet App</b> on your phone or Desktop.',
        'Scan the <b>QR code</b> from the Wallet App <br /> OR<br /> Copy & Paste the Wallet address in your wallet app.',
        'Enter the <b>[wallet] amount</b> in your Wallet App if its not prefilled. (Do not enter the USD amount)',
        this.anyWalletCoin.networkMsg || '',
      ];
      
      // Add CCD balance instruction for CCD, USDR, and EURR tokens
      if (isCCDNetworkToken) {
        cloneSheeps.push(this.$t('qr-wallet.ccdBalanceInstruction', { currency }));
      }
      
      cloneSheeps.push(
        'Proceed with <b>Send/Transfer</b> payment in your Wallet App.',
        `Wait for the ${label} payment page to update and show the transaction status. <br /> In some cases, it can take a few minutes to update the status because of the blockchain network`
      );
      
      return cloneSheeps;
    },
    processedInstructionsList() {
      const currency = this.anyWalletCoin?.currency?.toUpperCase() || '';
      const isCCDNetworkToken = CCD_NETWORK_TOKENS.includes(currency);
      const baseList = [...this.instructionsList];
      
      // Add CCD balance instruction for CCD, USDR, and EURR tokens
      // Insert after step 2 (Enter the amount) and before step 3 (Proceed with Send/Transfer)
      if (isCCDNetworkToken && baseList.length >= 3) {
        baseList.splice(3, 0, this.$t('qr-wallet.ccdBalanceInstruction', { currency }));
      }
      
      return baseList;
    },
  },
};
</script>
<style lang="scss" scoped>
.instruction-note {
  line-height:1.7;
  font-size:12px;
  margin-left:25px !important;
  font-weight:500;
}
</style>
